<template>
  <el-card shadow="never" class="card">
    <div slot="header" class="card-header">
      <i class="el-icon-info"></i>
      <span>游客基本信息</span>
    </div>

    <el-form :model="form" label-width="120px" class="form">
      <el-row :gutter="16">
        <el-col :span="8">
          <el-form-item label="游客渠道" required>
            <el-select
              :value="form.channel"
              placeholder="请选择渠道来源"
              style="width: 100%"
              @input="updateField('channel', $event)"
            >
              <el-option v-for="option in channelOptions" :key="option" :label="option" :value="option" />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="订单/交易/团号" required>
            <el-input
              :value="form.orderNo"
              placeholder="请输入订单号，系统将检查是否重复"
              @input="updateField('orderNo', $event)"
              @blur="onOrderNoBlur"
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="入园日期" required>
            <el-select
              :value="form.visitDate"
              placeholder="请选择入园日期"
              style="width: 100%"
              @input="updateField('visitDate', $event)"
            >
              <el-option v-for="d in visitDateOptions" :key="d" :label="d" :value="d" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16">
        <el-col :span="8">
        <el-form-item label="供应商单位名称">
            <el-input
              :value="form.supplier"
              placeholder="请输入供应商单位名称（非必填）"
              :disabled="supplierDisabled"
              @input="updateField('supplier', $event)"
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="达人名称">
            <el-input
              :value="form.talent"
              placeholder="请输入达人名称（非必填）"
              @input="updateField('talent', $event)"
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="提成比例(%)">
            <el-input
              :value="form.commission"
              placeholder="请输入提成比例"
              @input="updateField('commission', $event)"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>

<script>
import { checkOrderNo } from '../api'

export default {
  name: 'BaseInfoForm',
  props: {
    form: {
      type: Object,
      required: true
    },
    supplierDisabled: {
      type: Boolean,
      default: false
    },
    channelOptions: {
      type: Array,
      default: () => []
    }
    ,
    visitDateOptions: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    updateField(field, value) {
      this.$emit('update:form', { ...this.form, [field]: value })
    },
    async onOrderNoBlur() {
      const orderNo = this.form.orderNo && this.form.orderNo.trim()
      if (!orderNo) return

      try {
        const result = await checkOrderNo(orderNo)
        if (result.exists) {
          this.$message.warning('订单号重复，请检查！')
        }
      } catch (e) {
        // 静默处理，避免影响用户体验
        console.error('检查订单号失败:', e)
      }
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 16px;
  border-radius: 6px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #409eff;
  font-weight: 700;
}
</style>

